import Material from "./Material";
import apiTextureMaterialSchema from "../../services/bimVisualizerApi/schema/material/apiTextureMaterialSchema";
import MaterialTypeEnum from "../../enums/MaterialTypeEnum";

export default class TextureMaterial extends Material {

    mainTextureUrl: string;
    normalMapUrl?: string;

    constructor(materialId: number, mainTextureUrl: string, normalMapUrl: string | null) {
        super(MaterialTypeEnum.TextureMaterial, materialId);
        this.mainTextureUrl = mainTextureUrl;
        this.normalMapUrl = normalMapUrl ?? undefined;
    }

    static fromJSON(json: any): TextureMaterial {
        const parsed = apiTextureMaterialSchema.parse(json);
        return new TextureMaterial( parsed.id, parsed.mainTextureUrl, parsed.normalMapUrl);
    }
}